// src/pages/customers/Customers.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const statusBadge = (s) => {
  const map = { active: 'badge-success', inactive: 'badge-gray', disconnected: 'badge-danger', suspended: 'badge-warning' };
  return <span className={`badge ${map[s] || 'badge-gray'}`}>{s}</span>;
};

const fmt = (n) => parseFloat(n || 0).toLocaleString('en-KE', { minimumFractionDigits: 2 });

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ page, limit: 20 });
      if (search) params.append('search', search);
      if (status) params.append('status', status);
      const res = await api.get(`/customers?${params}`);
      setCustomers(res.data.data);
      setTotal(res.data.total);
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => { fetchCustomers(); }, [page, status]);
  useEffect(() => {
    const t = setTimeout(fetchCustomers, 400);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <div className="page-body">
      <div className="page-header">
        <div>
          <h1>Customers</h1>
          <p>{total} customers registered</p>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/customers/new')}>
          + New Customer
        </button>
      </div>

      {/* Filters */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <div className="search-bar" style={{ flex: 1, minWidth: 200 }}>
            <span>🔍</span>
            <input
              placeholder="Search name, account number, phone..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <select
            className="form-control"
            style={{ width: 160 }}
            value={status}
            onChange={e => { setStatus(e.target.value); setPage(1); }}
          >
            <option value="">All Statuses</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="disconnected">Disconnected</option>
            <option value="suspended">Suspended</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Account No.</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Location</th>
                <th>Status</th>
                <th style={{ textAlign: 'right' }}>Balance Due</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40 }}>
                  <div className="spinner" style={{ margin: '0 auto' }}></div>
                </td></tr>
              ) : customers.length === 0 ? (
                <tr><td colSpan={7}>
                  <div className="empty-state">
                    <h3>No customers found</h3>
                    <p>Add your first customer to get started</p>
                    <button className="btn btn-primary" onClick={() => navigate('/customers/new')}>
                      + New Customer
                    </button>
                  </div>
                </td></tr>
              ) : customers.map(c => (
                <tr key={c.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/customers/${c.id}`)}>
                  <td><code style={{ fontSize: 12 }}>{c.account_number}</code></td>
                  <td><strong>{c.full_name}</strong></td>
                  <td>{c.phone || '—'}</td>
                  <td>{c.location_name || c.estate_name || '—'}</td>
                  <td>{statusBadge(c.status)}</td>
                  <td style={{ textAlign: 'right' }}>
                    <span className={`amount ${parseFloat(c.balance_due) > 0 ? 'amount-red' : 'amount-green'}`}>
                      KES {fmt(c.balance_due)}
                    </span>
                  </td>
                  <td>
                    <button className="btn btn-outline btn-sm"
                      onClick={e => { e.stopPropagation(); navigate(`/customers/${c.id}`); }}>
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {total > 20 && (
          <div className="pagination">
            <button className="page-btn" onClick={() => setPage(p => Math.max(1, p-1))} disabled={page === 1}>‹</button>
            <span style={{ fontSize: 12, color: '#64748b', padding: '0 8px' }}>
              Page {page} of {Math.ceil(total / 20)}
            </span>
            <button className="page-btn" onClick={() => setPage(p => p+1)} disabled={page >= Math.ceil(total/20)}>›</button>
          </div>
        )}
      </div>
    </div>
  );
}
